// import React, { useEffect, useState } from "react";
// import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import UsercustomerService from "../Masters/Usercustomers/UsercustomerService.js";
// import SettingsServices from "../Settings/SettingsServices.js";
// import Credentials, { currentTenant, transactionFrom, userid } from "../Common/Credentials.js";
// import dashboardIcon from "../images/Icons/dashboard.png"
// import wagesIcon from "../images/Icons/wages.png"
// import transactionsIcon from "../images/Icons/transaction.png"
// import reportsIcon from "../images/Icons/annual-report.png"
// import { Backdrop } from "@mui/material";
// import "../NewUI/NewMenu.css"; // Import the new CSS file
// import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";

// const AccountsMenu = () => {
//   const [hovered, setHovered] = useState(null);
//   const [dnrequired, setDnrequired] = useState(true);
//   const [usercustomers, setUsercustomers] = useState(false);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Accounts");
//     SettingsServices.GetSettings(currentTenant).then((response) =>
//       setDnrequired(response.data.dnreq)
//     );
//     UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
//       setUsercustomers(res.data === '' || res.data === undefined || res.data === null ? false : true)
//     );
//   }, []);

//   return (
//     <div>
//       <Backdrop
//         sx={{
//           color: "#fff",
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//         open={transactionFrom === null}
//       >
//         <div className="menu-backdrop-content">
//           <div className="d-flex justify-content-center">
//             <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
//           </div>
//           <div className="d-flex justify-content-center">
//             <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
//           </div>
//         </div>
//       </Backdrop>

//       <Header />
//       <Menu />

//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">
//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <Breadcrumb breadcrumbs={[{name:"Home",path:"/index"},{name:"Accounts",path:null}]}/>
//               {/* <nav className="menu-breadcrumb">
//                 <Link
//                   to="/accounts"
//                   className="menu-breadcrumb-link"
//                   onMouseEnter={() => setHovered('home')}
//                   onMouseLeave={() => setHovered(null)}
//                 >
//                   Home
//                 </Link>
//                 <span>/</span>
//                 <span className="menu-breadcrumb-active">
//                   Accounts
//                 </span>
//               </nav> */}

//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                 </ul>

//                 <div className="menu-sections-container">
//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon" width="25" src={transactionsIcon} />
//                       <span className="menu-section-title-text">Transactions</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       {screens.includes("Sub Heads / Groups") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/subheads" }}
//                             state={{ message: "" }}
//                           >
//                             Sub Heads / Groups / Capital
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Create Ledger") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/newledgers" }}
//                             state={{ message: "" }}
//                           >
//                             Create Ledger
//                           </Link>
//                         </li>
//                         : ""}
//                       {screens.includes("Journal Entry") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/journals" }}
//                             state={{ message: "" }}
//                           >
//                             Journal Entry
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Salary Entry") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/salentry" }}
//                             state={{ message: "" }}
//                           >
//                             Salary Entry
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Direct Stocks") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/dirstock" }}
//                             state={{ message: "" }}
//                           >
//                             Direct Stocks
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Accounts Payable") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/ap" }}
//                             state={{ message: "" }}
//                           >
//                             Accounts Payable
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Accounts Receivable") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/ar" }}
//                             state={{ message: "" }}
//                           >
//                             Accounts Receivable
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Direct Taxes") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/dtaxes" }}
//                             state={{ message: "" }}
//                           >
//                             Direct Taxes
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Indirect Taxes") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/indirtaxes" }}
//                             state={{ message: "" }}
//                           >
//                             Indirect Taxes
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Losses Entry") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/lossesl" }}
//                             state={{ message: "" }}
//                           >
//                             Losses Entry
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Assets Loses/Expenses") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/depreciationl" }}
//                             state={{ message: "" }}
//                           >
//                             Assets Loses/Expenses
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Rectification Entries") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/rectifications" }}
//                             state={{ message: "" }}
//                           >
//                             Rectification Entries
//                           </Link>
//                         </li> : ""}
//                       {screens.includes("Debit Credit Notes") ?
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/debitcreditnotes" }}
//                             state={{ message: "" }}
//                           >
//                             Debit Credit Notes
//                           </Link>
//                         </li> : ""}
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/salesdirectcndn" }}
//                           state={{ message: "" }}
//                         >
//                           Direct CN/DN Entry
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>

//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon-payroll" src={wagesIcon} />
//                       <span className="menu-section-title-text">Payroll</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/employeesalary" }}
//                           state={{ message: "" }}
//                         >
//                           Employees Salary
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>

//                   {screens.includes("Accounts Reports") ?
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon-reports" src={reportsIcon} />
//                         <span className="menu-section-title-text">Reports</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/trialbalance" }}
//                             state={{ message: "" }}
//                           >
//                             Trial Balance
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/pandl" }}
//                             state={{ message: "" }}
//                           >
//                             P&L
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/reports/profit-and-loss" }}
//                             state={{ message: "" }}
//                           >
//                             P&L (Schedule III)
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/balancesheet" }}
//                             state={{ message: "" }}
//                           >
//                             Balance Sheet
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/newledgerview" }}
//                             state={{ message: "" }}
//                           >
//                             Party Ledgers View
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/bankstransreport" }}
//                             state={{ message: "" }}
//                           >
//                             Bank/Cash Ledgers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/ledgernominal" }}
//                             state={{ message: "" }}
//                           >
//                             Income-Gain/Exp-Loss Ledgers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/ledgerreal" }}
//                             state={{ message: "" }}
//                           >
//                             Asset/Liabilities Ledgers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             state={{ message: "" }}
//                           >
//                             Completed Pmt/Rects
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/ledgeradv" }}
//                             state={{ message: "" }}
//                           >
//                             Advances
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                     : ""}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(AccountsMenu);







import React from 'react';
import {
  FolderLock,
  ArrowRightLeft,
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse,
  Users,
  Building2,
  Truck,
  Grid,
  Handshake,
  Calculator,
  ShieldUser,
  Plus,
  CreditCard,
  Coins,
  Scale,
  TrendingUpDown,
  BanknoteArrowDown,
  BanknoteArrowUp,
  BookOpenCheck,
  FilePenLineIcon,
  Banknote,
  Settings
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import { id } from 'date-fns/locale';
import Layout from '../Component/Layout';

const AccountsMenu = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections = [
 {
 title: 'Transactions',
 subtitle: 'Double entry general adjustments',
 icon: ShieldUser,
 iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
 items: [
 {
 id: 'sub_heads',
 label: 'Sub Heads / Groups',
 desc: 'Logical charts of accounts categories',
 icon: FileText,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700',
 path: '/subheads',
 brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1'
 },
 {
 id: 'cre_ledg',
 label: 'Create Ledger',
 desc: 'Configure safe ledger drawers',
 icon: Plus,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 hover:tw-bg-teal-100 tw-text-teal-700',
 path: '/newledgers',
 brandColor: theme === "classic" ? '#4d4d4d' : '#14B8A6'

 },
 {
 id: 'jour_ent',
 label: 'Journal Entry',
 desc: 'Manual audits or double entry balances',
 icon: Calculator,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700',
 path: '/journals',
 brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6'
 },
 {
 id: 'sal_ent',
 label: 'Salary Entry',
 desc: 'Monthly wage dispersals signatures',
 icon: Calculator,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-purple-50 hover:tw-bg-purple-100 tw-text-purple-705',
 path: '/salentry',
 brandColor: theme === "classic" ? '#4d4d4d' : '#7C3AED'
 },
 {
 id: 'acc_pay',
 label: 'Accounts Payable',
 desc: 'Active pending supplier dues',
 icon: BanknoteArrowUp,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 tw-text-rose-700',
 path: '/ap',
 brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E'
 },
 {
 id: 'acc_rec',
 label: 'Accounts Receivable',
 desc: 'Delayed client payments directories',
 icon: BanknoteArrowDown,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700',
 path: '/ar',
 brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
 },
 {
 id: 'dtaxes',
 label: 'Direct Taxes',
 desc: 'Income tax, TDS, TCS and other direct tax entries',
 icon: Coins,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-yellow-50 hover:tw-bg-yellow-100 tw-text-yellow-700',
 path: '/dtaxes',
 brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B'
 },
 {
 id: 'indirtaxes',
 label: 'Indirect Taxes',
 desc: 'GST, VAT, Service tax and other indirect tax entries',
 icon: Coins,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-yellow-50 hover:tw-bg-yellow-100 tw-text-yellow-700',
 path: '/indirtaxes',
 brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B'
 },
 {
 id: 'debitcreditnotes',
 label: 'Debit/Credit Notes',
 desc: 'Customer and supplier debit/credit adjustments',
 icon: FilePenLineIcon,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700',
 path: '/debitcreditnotes',
 brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6'
 },
 {
 id: 'salesdirectcndn',
 label: 'Direct CN/DN Entry',
 desc: 'Direct debit/credit notes bypassing invoicing',
 icon: FilePenLineIcon,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700',
 path: '/salesdirectcndn',
 brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6'
 },
 {
 id: 'losses_entry',
 label: 'Losses Entry',
 desc: 'Write-off non-operational losses',
 icon: TrendingDown,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 tw-text-rose-700',
 path: '/lossesentry',
 brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E'
 },
 {
 id: 'depreciation_entry',
 label: 'Assets Losses/Expenses',
 desc: 'Depreciation and amortization entries',
 icon: TrendingDown,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 tw-text-rose-700',
 path: '/depreciationl',
 brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E'
 },
 {
      id: 'profit_dist_wizard',
      label: 'Profit Distribution Wizard',
      desc: 'End of year profit distribution process',
      icon: Calculator,
      brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-green-50 hover:tw-bg-green-100 tw-text-green-700',
      path: '/profitdistribution',
      brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
    },
    {
      id: 'dist_settings',
      label: 'Distribution Settings',
      desc: 'Configure Statutory Reserve limits',
      icon: Settings,
      brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-slate-50 hover:tw-bg-slate-100 tw-text-slate-700',
      path: '/distributionsettings',
      brandColor: theme === "classic" ? '#4d4d4d' : '#64748B'
    },
    {
      id: 'partner_current',
      label: 'Partner Current / Owner Equity',
      desc: 'Annual partner current allocations and drawings',
      icon: Calculator,
      brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700',
      path: '/partnercurrent',
      brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1'
    },
 {
 id: 'rectifications',
 label: 'Rectification Entries',
 desc: 'Error corrections and adjustments',
 icon: BookOpenCheck,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-yellow-50 hover:tw-bg-yellow-100 tw-text-yellow-700',
 path: '/rectifications',
 brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B'
 }
 ]
 },
{
 title: 'Payroll',
 subtitle: 'Employee direct salaries',
 icon: ShieldUser,
 iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
 items: [
 {
 id: 'employees_sal',
 label: 'Employees Salary Details',
 desc: 'Primary employee profiles and bank accounts',
 icon: Users,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700',
 path: '/employees',
 brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1'
 }
 ]
 },
 {
 title: 'Reports',
 subtitle: 'Real-time financial audits',
 icon: ShieldUser,
 iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
 items: [
 {
 id: 'rpt_trial',
 label: 'Trial Balance Sheet',
 desc: 'Reconciled debit-credit matching tallies',
 icon: Scale,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700',
 path: '/trialbalance',
 brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1'
 },
 {
 id: 'rpt_pl',
 label: 'P&L (Profit and Loss)',
 desc: 'Revolving monthly net yield vs overhead costs',
 icon: TrendingUpDown,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700',
 path: '/pandl',
 brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
 },
 {
 id: 'rpt_plsch3',
 label: 'P&L (Schedule III)',
 desc: 'Revolving monthly net yield vs overhead costs',
 icon: TrendingUpDown,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700',
 path: '/reports/profit-and-loss',
 brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
 },
  {
  id: 'rpt_bs_statement',
  label: 'Statement of Financial Position',
  desc: 'Comparative Balance Sheet, equity changes, cash flows & notes',
  icon: DollarSign,
  brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700',
  path: '/reports/financial-position',
  brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1'
  },
 {
 id: 'rpt_bs',
 label: 'Balance Sheet',
 desc: 'Aggregated assets, equities and liabilities status',
 icon: DollarSign,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-yellow-50 hover:tw-bg-yellow-100 tw-text-yellow-700',
 path: '/balancesheet',
 brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B'
 },
 {
 id: 'rpt_party_ledg',
 label: 'Party Ledgers View',
 desc: 'Comprehensive customer and supplier ledger summaries',
 icon: FileText,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700',
 path: '/newledgerview',
 brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6'
 },
 {
 id: 'rpt_bank_ledg',
 label: 'Bank / Cash Ledgers',
 desc: 'Synchronized bank clearing indicators',
 icon: Banknote,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700',
 path: '/bankstransreport',
 brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
 },
 {
 id: 'rpt_income_ledg',
 label: 'Income-Gain/Exp-Loss Ledgers',
 desc: 'Categorized profit and loss ledger summaries',
 icon: FileText,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700',
 path: '/ledgernominal',
 brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
 },
 {
 id: 'rpt_asset_ledg',
 label: 'Asset/Liabilities Ledgers',
 desc: 'Categorized asset and liabilities ledger summaries',
 icon: FileText,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700',
 path: '/ledgerreal',
 brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
 }, {
 id: 'rpt_completed_pmts',
 label: 'Completed Pmt/Rects',
 desc: 'Finalized payments and rectifications overview',
 icon: FileText,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700',
 path: '/completetran',
 brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
 },
 {
 id: 'rpt_advances',
 label: 'Advances',
 desc: 'Pending and reconciled advances summary',
 icon: FileText,
 brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700',
 path: '/ledgeradv',
 brandColor: theme === "classic" ? '#4d4d4d' : '#10B981'
 }
 ]
 }
 ]


  const onSelectItem = (path) => {
    navigate(path, { state: { message: "" } });
  }

  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>

      <Layout menu={"accounts"}>
        <div className="menu-container tw-mr-2 tw-ml-4">
          <div
            id="dashboard-content-area"
            className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4"
          >
            {/* Upper Hero Grid */}
            <div
              id="hero-welcome-banner"
              className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
            >
              {/* Background Blur Shapes */}
              <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

              <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

              {/* Left Content */}
              <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/index" }, { name: "Masters", path: null }]} />
                <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
                  Accounts & Payroll
                </h1>

                <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
                  Manage corporate balancing, write manual journal entries adjustments, process monthly staff salary packages profiles, and review Trial Balances.
                </p>
              </div>

              {/* 3D SVG Security Badging Illustration */}
              <div className="tw-flex tw-justify-center md:tw-justify-end tw-mt-4 md:tw-mt-0 tw-relative tw-group">
                <div className="tw-w-32 tw-h-32 relative tw-flex tw-items-center tw-justify-center" style={{ animationDuration: '4.4s' }}>
                  <div className="tw-absolute tw-bottom-4 tw-w-28 tw-h-3 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>

                  <Calculator size={80} className={(theme === "classic" ? "tw-text-[#4d4d4d]" : "tw-text-indigo-500") + " tw-drop-shadow-lg tw-animate-float"} />
                  {/* <svg viewBox="0 0 200 200" className="tw-w-32 tw-h-32 tw-drop-shadow-xl">
              <defs>
                <linearGradient id="scBody" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#FB923C" />
                  <stop offset="100%" stopColor="#EA580C" />
                </linearGradient>
              </defs>
              <ellipse cx="100" cy="160" rx="60" ry="10" fill="#1E293B" opacity="0.3" />

              <rect x="95" y="50" width="10" height="100" fill="#475569" rx="2" />
              <rect x="70" y="145" width="60" height="10" fill="#334155" rx="3" />

              <line x1="40" y1="65" x2="160" y2="65" stroke="#475569" strokeWidth="8" strokeLinecap="round" className="origin-center animate-pulse" />

              <line x1="40" y1="65" x2="30" y2="110" stroke="#94A3B8" strokeWidth="2" />
              <line x1="40" y1="65" x2="50" y2="110" stroke="#94A3B8" strokeWidth="2" />
              <ellipse cx="40" cy="110" rx="16" ry="4" fill="url(#scBody)" />

              <line x1="160" y1="65" x2="150" y2="110" stroke="#94A3B8" strokeWidth="2" />
              <line x1="160" y1="65" x2="170" y2="110" stroke="#94A3B8" strokeWidth="2" />
              <ellipse cx="160" cy="110" rx="16" ry="4" fill="url(#scBody)" />
            </svg> */}
                </div>
              </div>
            </div>

            {/* Main Grid */}
            <div
              id="erp-columns-grid"
              className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
            >


              {/* Menus */}
              {newsections.map((section) => {
                // const Icon = section.icon;
                return (
                  <div
                    key={section.title}
                    id="section-col-masters"
                    className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
                  >
                    <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
                      <div
                        className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
                      >
                        <FolderLock size={22} />
                        {/* <Icon size={22} color={section.iconColor} /> */}
                      </div>

                      <div>
                        <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
                          {section.title}
                        </h2>

                        <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
                          {section.subtitle}
                        </p>
                      </div>
                    </div>

                    <div className="tw-space-y-3 tw-flex-1">
                      {section.items.map((item) => {
                        const Icon = item.icon;

                        return (
                          <button
                            id={`subsection-btn-${item.id}`}
                            key={item.id}
                            onClick={() => onSelectItem(item.path)}
                            className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
                          >
                            <div className="tw-flex tw-items-center tw-gap-3.5">
                              <div
                                className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                              >
                                <Icon size={16} color={item.brandColor} />
                              </div>

                              <div>
                                <h4 className="tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors">
                                  {item.label}
                                </h4>

                                {/* <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                    {item.desc}
                  </p> */}
                              </div>
                            </div>

                            <ChevronRight
                              size={16}
                              className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
                            />
                          </button>
                        );
                      })}
                    </div>
                  </div>)
              }
              )}
            </div>

          </div>
        </div>
      </Layout>
    </div>
  );
}
export default withRouter(AccountsMenu);